"use client"
import { ContextPanelProps } from "./context-panel.types"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Section } from './components/section';
import { Header } from './components/header';
import classes from './context-panel.module.css';
import clsx from "clsx";
import { MenuItem } from "@/components/ui";


const ContextPanel = ({ header, tabs, className }: ContextPanelProps) => {
    const defaultValue = tabs[0].value;
    return <div className={clsx(classes.contextPanel, className)}>

        <Tabs defaultValue={defaultValue} className="w-full flex flex-col ">
            <Header {...header} />
            
            <div className="mt-4 flex relative grid">
                <TabsList className="place-self-center z-[1] border border-foreground/5 ring-background-context ring-4 bg-background-context">
                    {tabs.map((tab, index) => <TabsTrigger key={index} className={'rounded-xs'} value={tab.value}>{tab.label}</TabsTrigger>)}
                </TabsList>
                <div className="h-[1px] w-full bg-foreground/5 absolute top-1/2"></div>
            </div>
            
            {tabs.map((tab, index) => <TabsContent key={index} value={tab.value} className="space-y-3 overflow-y-auto absolute top-[176px] left-0 right-0 bottom-0">
                <ScrollArea className="h-full w-full p-5" inset>
                    {tab.sections && tab.sections.map((section, index) => <Section key={index} title={section.title}>{section.children}</Section>)}
                    {tab.actions && tab.actions.map((action, index) => <MenuItem key={index} {...action} className={'px-xsm py-xs space-x-xs leading-[24px]'} />)}
                </ScrollArea>
            </TabsContent>)}

        </Tabs>
    </div>
}

export { ContextPanel }
